<template>
  <div id="index">
    <Header ref="header"></Header>
    <!-- 报价详情 -->
    <div class="offerDetails" :class="morenDiv == false ? 'none':''">
      <div class="offerDetailsBox">
        <el-collapse v-model="activeNames" :disabled="true">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="offerDetailsTitle">
                <span>报价详情</span><button @click="goOfferList">返回</button></div>
            </template>
            <div class="offerDetailsCon">
              <div>
                <h5><span>采购编码：{{offerDetails.id}}</span><span>需求日期：{{offerDetails.realseTime}}</span></h5>
                <h5><span>产品名称：{{offerDetails.verietiesName}}</span><span>求购量：{{offerDetails.total}}{{offerDetails.unit}}</span></h5>
                <h5>质量要求：{{offerDetails.requirements}}</h5>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="offerTips">
          <img src="../assets/img/offerTipsIcon.png" alt="">温馨提示：您发布的报价，会立即发给买家，请详细填写，并真是报价，交易机会越大。
        </div>
        <el-form ref="formA" :model="form" label-width="100px">
          <el-form-item label="资质标准">
            <el-radio v-model="form.qualification" label="GMP证书">GMP证书</el-radio>
            <el-radio v-model="form.qualification" label="GSP证书">GSP证书</el-radio>
            <el-radio v-model="form.qualification" label="无证书">无证书</el-radio>
          </el-form-item>
          <el-form-item label="交货方式">
            <el-radio v-model="form.deliveryWay" label="分批交货">分批交货</el-radio>
            <el-radio v-model="form.deliveryWay" label="不分批交货">不分批交货</el-radio>
            <el-radio v-model="form.deliveryWay" label="可协商">可协商</el-radio>
          </el-form-item>
          <el-form-item label="发票类型">
            <el-radio v-model="form.invoiceType" label="增值税专票">增值税专票</el-radio>
            <el-radio v-model="form.invoiceType" label="普票">普票</el-radio>
            <el-radio v-model="form.invoiceType" label="无">无</el-radio>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-radio v-model="form.payType" label="银行转账">银行转账</el-radio>
            <el-radio v-model="form.payType" label="现金">现金</el-radio>
            <el-radio v-model="form.payType" label="账期">账期</el-radio>
            <el-radio v-model="form.payType" label="可协商">可协商</el-radio>
          </el-form-item>
          <el-form-item label="寄样">
            <el-radio v-model="form.sendSample" label="可以寄样">可以寄样</el-radio>
            <el-radio v-model="form.sendSample" label="无">无</el-radio>
            <el-radio v-model="form.sendSample" label="可协商">可协商</el-radio>
          </el-form-item>
          <el-form-item label="包装要求">
            <el-radio v-model="form.packages" label="挤压包">挤压包</el-radio>
            <el-radio v-model="form.packages" label="编织袋">编织袋</el-radio>
            <el-radio v-model="form.packages" label="纸箱">纸箱</el-radio>
            <el-radio v-model="form.packages" label="可协商">可协商</el-radio>
          </el-form-item>
          <el-form-item label="不含税价总价">
            <el-input v-model="form.amout" placeholder="请输入不含税价总价"></el-input>
          </el-form-item>
          <div class="el-formDiv">
            <el-form-item label="税价总价">
              <el-input v-model="form.taxPrice" placeholder="请输入税价总价"></el-input>
            </el-form-item>
            <el-form-item label="税率">
              <el-input v-model="form.tax" placeholder="请输入税率"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="货源说明">
            <el-input type="textarea" v-model="form.sourcesInstructions" placeholder="请输入介绍"></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="form.peopleLink" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            <el-button type="info" :disabled="disabled" @click="getCode">{{codeText}}</el-button>
          </el-form-item>
          <el-form-item class="Submit">
            <el-button type="primary" @click="getOfferAdd">提交</el-button>
            <el-button @click="quxiao">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
    <el-dialog :visible.sync="resultDialog" width="30%" :before-close="resultClose">
      <span>{{resultMessage}}</span>
    </el-dialog>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      disabled:false,
      codeText:'获取验证码',
      EWMImg:false,
      EWMButton:true,
      activeNames: ['1'],
      form: {
        images :'',
        demandInfoId :'',
        sendSample :'',
        amout :'' ,
        updateTime :'',
        tax :'',
        packages :'',
        userName :'',
        userId :'',
        qualification :'',
        isValidation :'' ,
        createBy :'',
        payType :'',
        createTime :'',
        updateBy :'',
        sourcesInstructions :'',
        peopleLink :'',
        phone :'',
        price :'' ,
        sysOrgCode :'',
        invoiceType :'',
        taxPrice :'' ,
        deliveryWay :'',
        code:''
      },
      offerDetails:{},
      resultDialog:false,
      resultMessage:''
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getOfferDetails()
  },
  methods: {
    getCode(){
      this.$fetch('getCode',{phone:this.form.phone}).then(res => {
        if(this.form.phone == null || this.form.phone == ''){
          alert("手机号不能为空！")
        }else if(!/^1[0-9]{10}$/.test(this.form.phone)){
            alert("手机号格式不正确！")
        }else{
          let maxNum = 45;
          let oldCodeText = this.codeText;
          this.codeText = `${maxNum}s重新发送`; //初始显示倒计时
          let codeCountDown = setInterval(() => {
          this.disabled = true;
          let countDownNum = maxNum--;
          this.codeText = `${countDownNum}s重新发送`;
          if (countDownNum == 0) {
            //倒计时结束
            this.codeText = oldCodeText;
            clearInterval(codeCountDown);
            this.disabled = false;
          }
        }, 1000);
        }
      })
    },
    goOfferList(){
      this.$router.push('/OfferList')
    },
    getOfferDetails(){
      this.$fetch('getOfferDetails',{id:this.$route.query.id}).then(res => {
       this.offerDetails = res.result;
       this.form = res.result
      })
    },
    getOfferAdd(){
      if(this.$cookie.get('account') == null){
        alert('请先登录，才能报价');
        return
      }
      this.form.id = '';
      this.form.userId = this.$cookie.get('account');
      this.form.demandInfoId = this.$route.query.id;
      console.log('getOfferAdd',this.form)
      this.$fetch('getOfferAdd',this.form).then(res => {
        if(res.code == 200){
          this.resultMessage = res.message;
          this.resultDialog = true;
          this.$router.push('/Index')
        }
      })
    },
    resultClose(){
      this.resultDialog = false
    },
    quxiao(){
      this.$refs[formA].resetFields(); // 重置表单并移除校验
    }
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/offerDetails.vue